/**
 * Timetable Studio — model barrel.
 *
 * The model was split into `studio/` for V3 (see docs/RESEARCH_STUDIO_V3_PLAN.md)
 * because a single 1,150-line module could not carry two modelling modes. This
 * file re-exports it under the old path so nothing outside the Studio has to
 * know, plus the three V2 conveniences that were plain arrays rather than
 * functions.
 *
 * Engine functions now take the NETWORK as their first argument. That is the
 * whole point of V3: the geography is data, so Mode A and Mode B are scored by
 * one engine rather than two forks of it.
 */
export * from './studio'

import { DEFAULT_TURNAROUND_MIN, throughNetwork } from './studio/network'
import type { Network } from './studio/types'

/** The Mode A network. Geometry is mode-independent, so this is safe for any
 *  purely geometric use (station names, journey times, timing-point grids). */
export const DEFAULT_NET: Network = throughNetwork()

export const STATIONS: string[] = DEFAULT_NET.stations.map((s) => s.name)
export const CUM_MIN: number[] = DEFAULT_NET.cumMin
export const TURNAROUND_MIN = DEFAULT_TURNAROUND_MIN
